import api from './axios';

export const listar    = ()          => api.get('/clientes-finais/');
export const buscarId  = (id)        => api.get(`/clientes-finais/${id}`);
export const criar     = (data)      => api.post('/clientes-finais/', data);
export const atualizar = (id, data)  => api.patch(`/clientes-finais/${id}`, data);

export const buscarPorCnpj      = (cnpj)  => api.get(`/clientes-finais/buscar-cnpj/${cnpj}`);
export const vincularEmpresa    = (id, idEmpresaOperadora)    => api.post(`/clientes-finais/${id}/vincular-empresa`, idEmpresaOperadora ? { id_empresa_operadora: idEmpresaOperadora } : {});
export const desvincularEmpresa = (id, idEmpresaOperadora)    => api.post(`/clientes-finais/${id}/desvincular-empresa`, idEmpresaOperadora ? { id_empresa_operadora: idEmpresaOperadora } : {});
